export default __webpack_public_path__ + "static/Api-b6750c765890e7f1361a7e29f85798fe.png";